import { Link } from "react-router-dom";
import { Palette } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";
import { useHeroBackground } from "~/hooks/useHeroBackground";

const APPEARANCE_PATH = "/nova/profile/appearance";

/** A quiet link from the Home banner to the Appearance tab, so users find the
 *  banner choices. Shown only until they pick one. */
export const BannerAppearanceShortcut = () => {
  const { hasChosenHeroBackground } = useHeroBackground();
  if (hasChosenHeroBackground) {
    return null;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to={APPEARANCE_PATH}
          aria-label="Change appearance"
          className="inline-flex size-9 items-center justify-center rounded-full text-white/80 transition-colors duration-300 hover:bg-white/20 hover:text-white focus-visible:ring-[3px] focus-visible:ring-white/40 focus-visible:outline-none"
        >
          <Palette className="size-5" />
        </Link>
      </TooltipTrigger>
      <TooltipContent side="bottom">Change appearance</TooltipContent>
    </Tooltip>
  );
};
